var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91429 10.9962L10.8536 7.05683C11.0489 6.86157 11.0489 6.54498 10.8536 6.34972L10.1465 5.64262C9.95126 5.44735 9.63468 5.44735 9.43942 5.64262L3.43942 11.6426C3.24415 11.8379 3.24415 12.1545 3.43941 12.3497L9.43942 18.3497C9.63468 18.545 9.95126 18.545 10.1465 18.3497L10.8536 17.6426C11.0489 17.4474 11.0489 17.1308 10.8536 16.9355L6.91429 12.9962L20.0001 12.9962C20.2762 12.9962 20.5001 12.7723 20.5001 12.4962L20.5001 11.4962C20.5001 11.22 20.2762 10.9962 20.0001 10.9962L6.91429 10.9962Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackForward);
export default __webpack_public_path__ + "static/media/iconBackForward.cee531074056b6b1c51aebb325e8949d.svg";
export { ForwardRef as ReactComponent };